import React, { useState, useRef } from 'react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import { Link } from 'react-router-dom';

gsap.registerPlugin(Flip);

const ModuleList = ({ modules = [] }) => {
  const [isGrid, setIsGrid] = useState(true);
  const containerRef = useRef(null);

  const toggleLayout = () => {
    const state = Flip.getState(containerRef.current.querySelectorAll('.card'));
    setIsGrid(!isGrid);
    Flip.from(state, {
      duration: 0.6,
      ease: 'power1.inOut',
      absolute: true,
      stagger: 0.04,
    });
  };

  return (
    <div>
      <button className="action-button" onClick={toggleLayout}>
        Switch to {isGrid ? 'List' : 'Grid'} View
      </button>
      <div
        ref={containerRef}
        className={isGrid ? 'module-grid' : 'module-list'}
        style={{ marginTop: '1rem' }}
      >
        {modules.map((mod) => (
          <div key={mod.id} className={`card ${mod.id}`} data-flip-id={mod.id}>
  <div className="title-wrapper">
  {mod.icon && (
    <img
      src={mod.icon}
      alt=""
      className="module-icon-inline"
    />
  )}
  <h2 className="module-heading">{mod.title}</h2>
</div>

  <p>{mod.description}</p>
  <Link className="button-link" to={`/module/${mod.id}`}>
    View Courses
  </Link>
</div>
        ))}
      </div>
    </div>
  );
};

export default ModuleList;
